<abcExpansionPanel
  *ngIf="commentsListData"
  [style]="4"
  [collapsible]="true"
  content
  [width]="'100%'"
  class="commentExpansion"
  [tooltip]="'Kommentare'"
>
  <div content="devExpress">
    <div *ngFor="let comment of commentsListData">
      <hr class="fadeStyle" />
      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxFill>
        <div class="profileImage" fxFlex="28px">{{ getFirstLettersFromName(comment.SysUserNameInsert) }}</div>
        <div fxFlex>
          <div fxLayout="column" fxLayoutAlign="start start">
            <span class="commentUserName">{{ comment.SysUserNameInsert }}</span>
            <span class="commentDate">{{ comment.DateInsert | date: 'EEEEEE dd.MM.yyyy' }}</span>
          </div>
          <p class="comment wrap" style="white-space: pre-wrap">{{ comment.Text }}</p>
        </div>
      </div>
    </div>
  </div>
</abcExpansionPanel>
<div *ngIf="comments && comments.length > 0">
  <div class="commentExpansion">
    <br />
    <div *ngFor="let comment of comments">
      <hr class="fadeStyle" />
      <div fxLayout="row" fxLayoutAlign="start start" class="commentBody" fxLayoutGap="10px" fxFill>
        <div class="profileImage" fxFlex="28px">{{ getFirstLettersFromName(comment.SysUserNameInsert) }}</div>
        <div fxFlex="calc(100% - 38px)" fxLayout="column" fxLayoutAlign="start start" fxFill>
          <div fxLayout="row" fxLayoutAlign="space-between" style="width: 100%">
            <div fxLayout="row" style="align-items: baseline">
              <span class="commentUserName">{{ comment.SysUserNameInsert }}</span>
              <span
                class="commentDate"
                *ngIf="
                  isCommentUpdated(
                    comment.SysDateInsert,
                    comment.SysDateUpdate,
                    comment.SysTimeInsert,
                    comment.SysTimeUpdate
                  )
                "
              >
                ({{ res('CommentsList-RefreshedBy') }} {{ comment.SysUserNameUpdate }} {{ res('CommentsList-In') }}
                {{ comment.SysDateUpdate | date: 'dd.MM.yyyy' }}, {{ comment.SysTimeUpdate | date: 'HH:mm:ss' }})
              </span>
            </div>
            <div *ngIf="!isReadOnly" fxLayout="row" class="buttonsList" style="align-content: flex-end">
              <mat-icon class="buttons" svgIcon="edit_com" (click)="editComment(comment)"></mat-icon>
              <mat-icon class="buttons" svgIcon="del_com" (click)="deleteComment(comment)"> </mat-icon>
            </div>
          </div>
          <span class="commentDate"
            >{{ comment.SysDateInsert | date: 'dd.MM.yyyy' }} | <span [innerHTML]="comment.Identifier"></span>
          </span>

          <p
            class="comment text"
            (click)="expandCollapseComment(comment)"
            [class.overflow]="isCommentExpanded.get(comment)"
            style="white-space: normal; width: 90%"
            [innerHTML]="comment.Comment"
          ></p>
        </div>
      </div>
    </div>
  </div>
</div>

<abcLoader [show]="showLoader && !commentsListData"></abcLoader>
<div style="min-height: 19px">
  <div *ngIf="comments.length === 0" class="noDataPlaceHolder">
    {{ res('CommentsList-NoComments') }}
  </div>
</div>

<div *ngIf="!commentsListData && !isReadOnly" class="fab-container">
  <button mat-fab class="fab-toggler" (click)="addComment()" [disabled]="!parentId">
    <i class="material-icons">add</i>
  </button>
</div>
